import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=7c269160"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c269160')) {
      api.createRecord('7c269160', component.options)
    } else {
      api.reload('7c269160', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=7c269160", function () {
      api.rerender('7c269160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/main/Main.vue"
export default component.exports